<template>
  <div>
    <div class="right_font">
      <el-tooltip class="item" effect="dark" content="显示变量路径提示文字" placement="left">
        <cx-check-box :value.sync="showSelectTooltip" class="mr8" />
      </el-tooltip>
      <p @click="addVariable" class="icon-portal-plus-small plugin_title"></p>
    </div>
    <div v-for="(item, key) in variable" :key="key" class="variable_item mb8">
      <div class="right_font"><p @click="delVariable(key)" class="icon-portal-delete plugin_title"></p></div>
      <div class="variable_set mt8">
        <div class="mr8 name">变量名</div>
        <el-input
          class="variable_value"
          :value="item.variableName"
          @input="changeVariableName(key, $event)"
          @change="changeEv('variableName', key, $event)"
          placeholder="请输入变量名"
        ></el-input>
      </div>
      <div class="variable_set mt16">
        <template v-if="getSelectOption">
          <cx-select
            title="变量路径"
            :value="item.variablePath"
            @change="changeEv('variablePath', key, $event)"
            tooltipPosition="left"
            :showTooltip="showSelectTooltip"
            :selectOptions="getSelectOption"
          />
        </template>
        <template v-else>
          <div class="mr8 name">变量路径</div>
          <el-input
            class="variable_value"
            :value="item.variablePath"
            @input="changeVariablePath(key, $event)"
            @change="changeEv('variablePath', key, $event)"
            placeholder="请输入变量路径"
          ></el-input>
        </template>
      </div>
      <!-- 自由布局 行列判断 -->
      <div class="variable_set mt16" v-if="!!ids.uid && item.variablePath === 'queryColValue'">
        <cx-select
            title="数据响应变量值"
            :value="item.variableColPath"
            @change="changeColEv('variableColPath', key, $event)"
            :selectOptions="filedMappingList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { handleFindLayoutComponentOptions, getValueByType } from "utils"
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentBigScreenUpdateData.js"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
export default {
  model: {
    prop: "variable"
  },
  props: {
    variable: Array,
    otherVariables: Array,
    component: {
      type: Boolean,
      default: false
    },
    selectOption: [Array || undefined]
  },
  data() {
    return {
      baseVariable: {
        variableName: "",
        variablePath: ""
      },
      showSelectTooltip: false,
      filedMappingList: [], // 用来做映射的字段集合
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getSelectOption() {
      return this.selectOption
    }
  },
  mounted() {
    const rectAttr = this.getRectAttribute(this.ids)
    if(rectAttr.options.noCacheComponent && this.ids.uid){
      this.getQueryData(rectAttr)
    }
  },
  methods: {
    changeEv(type, key, value = value.trim()) {
      //检查变量名和变量值是否重复
      const findSameVariableIndex = this.variable
        .filter((item, index) => index !== key)
        .findIndex(item => item[type] === value)
      if (findSameVariableIndex !== -1) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "warning",
          message: `不能设置相同变量${type == "variablePath" ? "路径" : "名"},已为您将错误值保存至剪切板，请重新填写`
        })
        this.copyToClip(this.variable[key][type])
        this.variable[key][type] = ""
        return
      }
      //如果有该参数，且当前正在改的是变量名，证明该配置项同时还需要检查是否与别的变量的变量名冲突
      if (type === "variableName" && this.otherVariables?.length) {
        for (let i = 0; i < this.otherVariables.length; i++) {
          const var1 = this.otherVariables[i]
          const findIndex = var1.findIndex(it => it.variableName === value)
          if (findIndex !== -1) {
            const item = this.variable.find(it => it.variableName === value)
            //如果找到了 就把该变量名清空
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              type: "warning",
              message: `不能设置与组件变量或参数变量中任意一个相同的变量名,已为您将错误值保存至剪切板，请重新填写`
            })
            this.copyToClip(item.variableName)
            item.variableName = ""
            return
          }
        }
      }
      //如果是组件配置项变量 则需要检测是否有该配置项
      if (this.component && type === "variablePath") {
        const stage = this.$store.state[this.request_prefix]
        let rectAttr = this.getAttrById(stage, this.$store.state.states.activeID)
        rectAttr = rectAttr.options ? rectAttr.options : rectAttr
        const names = value.split(".")
        for (let i = 0; i < names.length; i++) {
          if (rectAttr.hasOwnProperty(names[i])) {
            if(rectAttr.queryColValue && value !== 'queryColValue'){
              this.$changeOptionsEV('', "queryColValue", false, null, {
                rect_id: this.ids.rect_id,
                container_id: this.ids.container_id
              })
              this.variable[key].variableColPath = ''
            }
            rectAttr = rectAttr[names[i]]
          } else {
            //自由布局列的特殊值判定，默认取值为0
            if(value === 'queryColValue'){
              this.$changeOptionsEV(value, "queryColValue", false, null, {
                rect_id: this.ids.rect_id,
                container_id: this.ids.container_id
              })
            }else{
              rectAttr = undefined
              break
            }
          }
        }
        if (rectAttr === undefined) {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "warning",
            message: `无效变量路径，已为您将错误值保存至剪切板，请检查后重新填写！`
          })
          this.copyToClip(this.variable[key][type])
          this.variable[key][type] = ""
          return
        }
        this.changeVariablePath(key, value)
      }
    },
    addVariable() {
      this.variable.push({ ...this.baseVariable })
    },
    changeVariableName(key, value = value.trim()) {
      this.variable[key].variableName = value
    },
    changeVariablePath(key, value = value.trim()) {
      this.variable[key].variablePath = value
    },
    delVariable(key) {
      this.variable.splice(key, 1)
    },
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    async getAppointDataEv() {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam.appId
      return await getAppointCacheData.call(
          this,
          pageId,
          wfwfid,
          websiteId,
          appId,
          { useSubPageQuery: rectAttr.options.useSubPageQuery, selectedDetailParam: rectAttr.options.selectedDetailParam }
      )
    },
  // 可选择传参的变量
    async getQueryData(rectAttr){
      //此处引用自由布局的方法是为了获取自由布局的外接数据，后期考虑是否修改引用方法【例如直接从属性中获取】避免步骤过于复杂去请求数据
      const updateLayoutData = new UpdateLayoutData(this)
      const { cacheDataTypes, restDataUrl, generalDataTypes } = await this.getAppointDataEv()
      let { activeIndex } = rectAttr.options
      const { completeData, colsIdFromActiveRect } = await updateLayoutData.upDateRect({
        activeIndex,
        rectAttr,
        cacheDataTypes,
        restDataUrl,
        ids: {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        categoryMode: rectAttr?.options?.categoryMode,
        renderModel: rectAttr?.options?.pluginName?.includes('renderTypeCol') ? 'type' : 'data',
        wholeDataTypes: generalDataTypes
      })
      activeIndex = colsIdFromActiveRect.findIndex(item => item == this.ids.uid)
      const res = []
      if (completeData && completeData[activeIndex]) {
        // 组装字段映射的数据结构
        Object.keys(completeData[activeIndex]).forEach((key, index) => {
          if (key !== "url" && key !== "publicId" && key !== "id" && key !== "pageType" && key !== "viewNum") {
            res.push({
              value: key,
              label: completeData[activeIndex][key]?.key
            })
          }
          if (key === "viewNum") {
            res.push({
              value: key,
              label: "浏览量"
            })
          }
        })
      }
      this.filedMappingList = res
    },
    changeColEv(type, key, value = value.trim()){
      this.$changeOptionsEV(value, "queryColValue", false, null, {
        rect_id: this.ids.rect_id,
        container_id: this.ids.container_id
      })
      this.variable[key][type] = value
    }
  }
}
</script>

<style scoped>
.variable_set {
  display: flex;
  align-items: center;
}
.name {
  width: 30%;
}
.variable_value {
  width: 70%;
}
.right_font {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 18px;
}
.plugin_title {
  display: inline-block;
}
.plugin_title:hover {
  cursor: pointer;
}
.variable_item {
  border: 1px solid gray;
  padding: 10px 15px;
  border-radius: 4px;
}
</style>
